import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, throwError } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { NetworkSpeedService } from '../services/network-speed.service';
import { CrashMonitorService } from '../services/crash-monitor.service';

let loadingTimeout: ReturnType<typeof setTimeout> | undefined;

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const networkSpeedService = inject(NetworkSpeedService);
  const crashMonitor = inject(CrashMonitorService);

  loadingService.setLoading(true);
  loadingService.setSlowConnection(networkSpeedService.isSlow);

  return next(req).pipe(
    catchError(error => {
      crashMonitor.logApiError(error, req.url);
      return throwError(() => error
      )
    }),
    finalize(() => {
      if (loadingTimeout) clearTimeout(loadingTimeout);
      loadingTimeout = setTimeout(() => loadingService.setLoading(false), 2000);
    })
  );
};
